/**
 * BackButton Component
 *
 * Reusable back button component used across the application.
 */

import { Button } from '@soteria/design-system-ve';

interface BackButtonProps {
  /**
   * Click handler for the back button
   */
  onClick: () => void;
  /**
   * Optional aria-label for accessibility
   */
  'aria-label'?: string;
}

/**
 * Back button component
 *
 * A standardized back button that can be used throughout the application.
 * Uses IconButton from the design system with consistent styling and accessibility features.
 */
export function BackButton({ onClick, 'aria-label': ariaLabel = 'Go back to previous page' }: BackButtonProps) {
  return (
    <Button aria-label={ariaLabel} onClick={onClick}>
      Back
    </Button>
  );
}
